import AutoScroll from './auto_scroll.js';
import CodeHighlight from './code_highlight.js';
import AutoExpandTextarea from './auto_expand_textarea.js';
import ExtensionBridge from './extension_bridge.js';
import BrainboxTools from './brainbox_tools.js';
import LocalModel from './local_model.js';
import Clipboard from './clipboard.js';
import ClipboardPaste from './clipboard_paste.js';
import ViewportDetector from './viewport_detector.js';
import ThemeManager from './theme_manager.js';
import PlaceholderRotator from './placeholder_rotator.js';
import FileDrop from './file_drop.js';
import FileDropZone from './file_drop_zone.js';
import InfiniteScroll from './infinite_scroll.js';
import SettingsModal from './settings_modal.js';
import Dialog from './dialog.js';
import MarkdownRenderer from './markdown_renderer.js';
import MentionAutocomplete from './mention_autocomplete.js';
import ContentEditableInput from './contenteditable_input.js';
import {FileInputDropdownClose} from './file_input_dropdown_close.js';
import ScreenshotCapture from './screenshot_capture.js';
import FlashAutoDismiss from './flash_auto_dismiss.js';
import SkillAutocomplete from './skill_autocomplete.js';
import SkillPickerKeyboard from './skill_picker_keyboard.js';
import MessageForm from './message_form.js';
import SpeechToText from './speech_to_text.js';
import WaveboxSuggestionChip from './wavebox_suggestion_chip.js';
import BrowserScreenshotPicker from './browser_screenshot_picker.js';

export default {
  AutoScroll,
  CodeHighlight,
  AutoExpandTextarea,
  ExtensionBridge,
  BrainboxTools,
  LocalModel,
  Clipboard,
  ClipboardPaste,
  ViewportDetector,
  ThemeManager,
  PlaceholderRotator,
  FileDrop,
  FileDropZone,
  InfiniteScroll,
  SettingsModal,
  Dialog,
  MarkdownRenderer,
  MentionAutocomplete,
  ContentEditableInput,
  FileInputDropdownClose,
  ScreenshotCapture,
  FlashAutoDismiss,
  SkillAutocomplete,
  SkillPickerKeyboard,
  MessageForm,
  SpeechToText,
  WaveboxSuggestionChip,
  BrowserScreenshotPicker
};
